export const getFileEntry = submission => {
    const defaultRes = {
        key: "",
        value: ""
    };
    if (!submission) return defaultRes;

    const entries = Object.entries(submission?.files || {});
    if (entries.length !== 1) return defaultRes;
    else return {
        key: entries[0][0],
        value: entries[0][1]
    };
}